export const environment = {
    production: true,
    apiUrl: 'http://api.garibaldi.cl/api', // EN LOCAL
    // apiUrl: 'https://apidev.garibaldi-group.com/api', // EN DEV
    GenericCrudOperation: 'admin/crud',
    EndPointCrud:'admin/crud/get',
    CompanyApps:'admin/crud/companyapps',    
    AppMenus:'admin/crud/appMenus',   
    updateCompanyApps: 'admin/crud/ActivateCompanyApps',
    createOrUpdateUserCompanyApps:'admin/crud/createorupdateusercompanyapps',
    getCompaniesByUserId: 'admin/crud/getCompaniesByUserId',
    getAppsByParams:'admin/crud/getAppsByParams',
    getMenusByParams : 'admin/crud/getMenusByParams',
    associateMenuToUser: 'admin/crud/associateMenuToUser',
    documentSearch: '/documentos/search',
    GetDocumentType : '/GetDocumentType',
    createOrUpdateDocumentTypes: 'admin/crud/createOrUpdateDocumentTypes',
    getGerenciasAreas: '/documentos/getGerenciasAreas',
    getdataDocumentoForEdit: 'admin/crud/getDocuments',
    GetCompaniesHasApps: 'admin/crud/getCompaniesHasApps',
    GetParentMenus: 'admin/crud/getParentMenus',
    CloneProfile: 'admin/crud/cloneProfile',
    CryptoKey: 'u1CAbbYUDhgKsl8h7gJBXmpMhWi9nfenjnBWKUqZCZQZEZP3EQff8y6A38LCzHQe',
    CreateOrUpdateDocumentAndHistorical: 'admin/crud/createOrUpdateDocumentAndHistorical',
    GetHistoricalDocuments: 'admin/crud/getHistoricalDocuments',
    GetCodeLines: 'admin/crud/getCodeLines',
    GetCodeFamilies: 'admin/crud/getCodeFamilies',
    GetCodeSubFamilies: 'admin/crud/getCodeSubFamilies',
    CreateRequestCode: 'admin/crud/createRequestCode',
    GetRequestCodeBySerialCode: 'admin/crud/getRequestCodeBySerialCode',
    GetAllRequestCodeByCompanyId: 'admin/crud/getAllRequestCodeByCompanyId',
    GetRequestCodeById: 'admin/crud/getRequestCodeById',
    ResolveRequest: 'admin/crud/resolveRequest',
    ModifyRequestCode: 'admin/crud/modifyRequestCode',
    CreateBinnacle: 'admin/crud/createBinnacle',
    GetProductionEquipments: 'admin/crud/getProductionEquipments',
    GetBinnaclesByCompanyId: 'admin/crud/getBinnaclesByCompanyId',
    GetLogs: 'admin/crud/getLogs',
    SendMailApproveOrReject: 'admin/crud/sendMailApproveOrReject',
    CreateNewBinnacleOTByIdWorkOrder: 'admin/crud/createNewBinnacleOTByIdWorkOrder',
    AssignBinnacleToNewWorkOrder: 'admin/crud/assignBinnacleToNewWorkOrder',
    GetWorkOrderWithRelations: 'admin/crud/getWorkOrderWithRelations',
    GetCollaborators: 'admin/crud/getCollaborators',
};
